import { useTranslation, Trans } from "react-i18next";
import { useState, useEffect } from "react";
import { message } from "antd";
import chLogo from "../assets/images/ch.png";
import hkLogo from "../assets/images/hk.png";
import sgLogo from "../assets/images/sg.png";
import "./ContactSection.scss";

import { getContactInfo } from "../apis/index.js";
import { coleectMessageRq } from "../apis/index";

const ContactSection = () => {
  const { t } = useTranslation();
  // 表单受控状态
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    conpanyName: "",
    message: "",
  });
  // ✅ 新增：存储接口请求的联系信息
  const [contactInfo, setContactInfo] = useState({});
  // ✅ 新增：请求loading状态（提交按钮防重复点击+加载中）
  const [loading, setLoading] = useState(false);

  // ✅ 1. 页面加载完成，请求联系信息数据 渲染页面
  // useEffect(() => {
  //   const fetchContactInfo = async () => {
  //     try {
  //       const res = await getContactInfo();
  //       if (res) {
  //         setContactInfo(res); // 接口数据存入状态，用于页面渲染
  //       }
  //     } catch (err) {
  //       console.error("获取联系信息失败：", err);
  //       message.error(t("contact.getInfoErr"));
  //     }
  //   };
  //   fetchContactInfo();
  // }, [t]);

  // 表单输入值改变事件
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ 2. 完善表单提交方法 - 调用接口提交表单数据
  const handleSubmit = async (e) => {
    e.preventDefault();
    // 防重复提交：加载中状态直接返回
    if (loading) return;

    try {
      setLoading(true);
      // 调用后端提交留言接口，传入表单数据
      await coleectMessageRq(form);
      // 提交成功提示
      message.success(t("contact.submitSuccess"));
      // 提交成功后重置表单
      setForm({
        name: "",
        email: "",
        phone: "",
        conpanyName: "",
        message: "",
      });
    } catch (err) {
      // 提交失败提示（接口报错信息会在request.js里统一弹窗，这里做兜底）
      message.error(t("contact.submitFail"));
      console.error("表单提交失败：", err);
    } finally {
      // 无论成功失败，关闭loading状态
      setLoading(false);
    }
  };

  return (
    <section className='contact-section'>
      <div className='container g-inner'>
        {/* 标题 */}
        <h2 className='contact-title'>{t("contact.title")}</h2>

        <div className='contact-wrap'>
          {/* 左侧：联系方式 - 优先用接口数据，无数据则用i18n翻译兜底 */}
          <div className='contact-info  sub-font'>
            {/* 邮箱 */}
            <div className='info-item'>
              <span className='icon'>✉️</span>
              <span className='content sub-font'>
                {contactInfo.email || t("contact.email")}
              </span>
            </div>

            {/* 地址列表 - 接口返回的地址列表优先渲染，无数据则用原有的兜底 */}
            {contactInfo.addressList && contactInfo.addressList.length > 0 ? (
              <div className='address-list'>
                {contactInfo.addressList.map((item, index) => (
                  <div className='address-item' key={index}>
                    <img
                      src={
                        item.type === "sg"
                          ? sgLogo
                          : item.type === "hk"
                          ? hkLogo
                          : chLogo
                      }
                      className='icon'
                    />
                    <div className='address-content'>
                      <p className='address-name  sub-font'>{item.name}</p>
                      <p className='address-detail  sub-font'>{item.address}</p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className='address-list'>
                <div className='address-item'>
                  <img src={sgLogo} className='icon' />
                  <div className='address-content'>
                    <p className='address-name  sub-font'>
                      {t("contact.sgName")}
                    </p>
                    <p className='address-detail  sub-font'>
                      {t("contact.sgAddr")}
                    </p>
                  </div>
                </div>
                <div className='address-item'>
                  <img src={hkLogo} className='icon' />
                  <div className='address-content'>
                    <p className='address-name  sub-font'>
                      {t("contact.hkName")}
                    </p>
                    <p className='address-detail  sub-font'>
                      {t("contact.hkAddr")}
                    </p>
                  </div>
                </div>
                <div className='address-item'>
                  <img src={chLogo} className='icon' />
                  <div className='address-content'>
                    <p className='address-name  sub-font'>
                      {t("contact.shName")}
                    </p>
                    <p className='address-detail  sub-font'>
                      {t("contact.shAddr")}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* 右侧：联系表单 */}
          <form className='contact-form' onSubmit={handleSubmit}>
            <div className='form-row'>
              <div className='form-group'>
                <label>{t("contact.formName")}</label>
                <input
                  type='text'
                  name='name'
                  value={form.name}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>
              <div className='form-group'>
                <label>{t("contact.formEmail")}</label>
                <input
                  type='email'
                  name='email'
                  value={form.email}
                  onChange={handleChange}
                  required
                  disabled={loading}
                />
              </div>
            </div>
            <div className='form-row'>
              <div className='form-group'>
                <label>{t("contact.formPhone")}</label>
                <input
                  type='tel'
                  name='phone'
                  value={form.phone}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
              <div className='form-group'>
                <label>{t("contact.formCompany")}</label>
                <input
                  type='text'
                  name='company'
                  value={form.conpanyName}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
            </div>
            <div className='form-group full-width'>
              <label>{t("contact.formMsg")}</label>
              <textarea
                name='message'
                value={form.message}
                onChange={handleChange}
                rows={4}
                disabled={loading}
              ></textarea>
            </div>
            <button type='submit' className='submit-btn' disabled={loading}>
              {loading ? t("contact.submitting") : t("contact.formSubmit")}
              <span className='iconfont'>&#xe69c;</span>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
